"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMount = void 0;
var react_1 = require("react");
var useMount = function () {
    var _a = __read((0, react_1.useState)(false), 2), isMount = _a[0], setMount = _a[1];
    (0, react_1.useEffect)(function () {
        setMount(true);
        return function () { return setMount(false); };
    }, []);
    return isMount;
};
exports.useMount = useMount;
